export default {
  en: {
    members_count: {
      one: '%{count} member',
      other: '%{count} members',
    },
  },
};
